import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6958f0d07683ed0014d70c6f_1789402887633_89398a60/practice_test_interface/src/app/privacy-policy/page.tsx");
